import { render, staticRenderFns } from "./CurrentDatePlaceInfo.vue?vue&type=template&id=0409450c&"
import script from "./CurrentDatePlaceInfo.vue?vue&type=script&lang=ts&"
export * from "./CurrentDatePlaceInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports